import React from 'react';
import { PTQuickLinkItem } from './prop-types';
import Link from '../../01_atoms/Link';
import Button from '../../01_atoms/Button';
import NextArrow from '../../../public/static/icons/next-arrow.svg';

import styles from './index.module.scss';

// TODO: re-write th component and styles. Do we need Button here?
const QuickLinkItem = ({ button, image, className = '' }) => (
  <div className={`quick-link-item ${styles['quick-link-item']}`}>
    <Link {...button.nextLink}>
      <a
        href={button.nextLink.url}
        className="quick-link-item-container analytics-quick-link"
        tabIndex="0"
      >
        {image && image.url && (
          <div
            style={{
              backgroundImage: `url("${image.url}")`,
            }}
            title={button.label}
            className="quick-link-item-background"
          />
        )}

        <div className="quick-link-item-box">
          <Button
            tag="button"
            type="quick-link"
            href={button.nextLink.url}
            className={className}
            tabIndex="-1"
          >
            {button.label}
            <span className="arrow" aria-hidden="true">
              <NextArrow />
            </span>
          </Button>
        </div>
      </a>
    </Link>
  </div>
);

QuickLinkItem.propTypes = PTQuickLinkItem;

export default QuickLinkItem;
